import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import React from 'react';
import { Form, OriNumberInput, OriCheckbox } from 'src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import { isNumber } from 'src/tools/helper';
import css from './css.module.less';
import { maxAmount } from 'src/tools/constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
const checkboxName = ['voucherQuantity', 'limited'];
const inputName = ['voucherQuantity', 'totalQuantity'];

const VoucherQuantity = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  return (
    <SectionWrapper
      title={getI18n('voucher.storeVoucherDetail.voucherQuantity')}>
      <ItemWrapper title={''}>
        <Item
          name={checkboxName}
          valuePropName={'checked'}
          className={css.checkbox}>
          <OriCheckbox disabled={disabled}>
            {getI18n('voucher.storeVoucherDetail.limitedquantity')}
          </OriCheckbox>
        </Item>
        {getI18n('voucher.storeVoucherDetail.limitedquantityTips')}
      </ItemWrapper>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, checkboxName);
          const cV = get(c, checkboxName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = getFieldValue(checkboxName);
          if (isDisplay) {
            return (
              <React.Fragment>
                <ItemWrapper
                  title={getI18n(
                    'voucher.storeVoucherDetail.totalVoucherQuantity',
                  )}>
                  <Item
                    className={css.inputContainer}
                    name={inputName}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value) || value < 0) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.totalVoucherQuantityValidate1',
                                ),
                              ),
                            );
                          }
                          if (value > maxAmount) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.totalVoucherQuantityValidate2',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      disabled={disabled}
                      max={maxAmount}
                      precision={0}
                      //decimalSeparator={0}
                    />
                  </Item>
                </ItemWrapper>
                <div className={css.tip}>
                  <Icon type='iconinfo2' className={css.infoIcon} />
                  {getI18n('voucher.storeVoucherDetail.voucherQuantityTips')}
                </div>
              </React.Fragment>
            );
          }
          return null;
        }}
      </Item>
    </SectionWrapper>
  );
};
export default VoucherQuantity;
